import React from 'react'

const NoMatch = () => (
	<div>
		<h1>Page not found!</h1>
		<p>The page you are looking for is not found</p>
	</div>
)

export default NoMatch



// WEBPACK FOOTER //
// ./src/routes/NoMatch.js